// export const icons_dict = {
//   1: () => (
//     <svg
//       width="80"
//       height="80"
//       viewBox="0 0 80 80"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g>
//         <path
//           d="M75.9174 19.4283L69.4063 7.55053C69.3396 7.42831 69.273 7.32831 69.173 7.20608C68.5063 6.18386 67.173 5.49497 66.0507 5.56164H13.2396C12.0285 5.48386 10.7063 6.17275 10.0396 7.19497C9.95074 7.30608 9.88408 7.4172 9.8063 7.55053L3.28408 19.4283C1.73963 21.8061 1.89519 25.4728 3.65074 27.8061C4.76185 29.295 6.47296 30.3394 8.52852 30.8839V68.2839C8.52852 71.0839 11.0174 73.3616 14.0841 73.3616H64.8952C67.9619 73.3616 70.4507 71.0839 70.4507 68.2839V30.9394C72.6063 30.4172 74.3952 29.3505 75.5507 27.8061C77.2952 25.4728 77.4507 21.8061 75.9174 19.4283Z"
//           fill="currentColor"
//         />
//       </g>
//     </svg>
//   ),
//   3: () => (
//     <svg
//       width="80"
//       height="80"
//       viewBox="0 0 80 80"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g>
//         <path
//           d="M65.995 76.5971H15.595C12.4173 76.5971 9.82837 73.9971 9.82837 70.7971V37.9749H8.26171C6.09504 37.9749 4.2506 36.6304 3.58393 34.5527C2.91726 32.4749 3.60615 30.3082 5.3506 29.0193L36.895 5.75267C39.2617 4.00822 42.3284 4.00822 44.695 5.75267L76.2395 29.0304C77.9728 30.3193 78.6728 32.486 77.995 34.5527C77.3284 36.6304 75.4839 37.9749 73.3173 37.9749H71.7506V70.7971C71.7506 73.9971 69.1617 76.5971 65.9839 76.5971H65.995Z"
//           fill="currentColor"
//         />
//       </g>
//     </svg>
//   ),
//   2: () => (
//     <svg
//       width="80"
//       height="80"
//       viewBox="0 0 80 80"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g>
//         <path
//           d="M64.2555 48.7886C59.7889 46.2775 54.7111 44.9441 49.5889 44.9441H48.3778C56.2666 41.7219 61.8333 33.9775 61.8333 24.9441C61.8444 13.0219 52.1444 3.33301 40.2333 3.33301C28.3222 3.33301 18.6333 13.0219 18.6333 24.9441C18.6333 33.9775 24.2111 41.7219 32.0889 44.9441H30.8778C25.7555 44.9441 20.6889 46.2775 16.2111 48.7886C6.89997 54.0108 1.11108 63.8108 1.11108 74.3552C1.11108 75.1219 1.73331 75.7441 2.49997 75.7441H77.9777C78.7444 75.7441 79.3666 75.1219 79.3666 74.3552C79.3666 63.8108 73.5778 54.0108 64.2555 48.7775V48.7886Z"
//           fill="currentColor"
//         />
//       </g>
//     </svg>
//   ),
//   4: () => (
//     <svg
//       width="80"
//       height="80"
//       viewBox="0 0 80 80"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clipPath="url(#clip0_2905_13200)">
//         <path
//           d="M80.6 36.7003V23.1114C80.6 20.6559 78.6111 18.667 76.1556 18.667H71.1556V12.2225C71.1556 9.15588 68.6667 6.66699 65.6 6.66699H14.7889C11.7222 6.66699 9.23333 9.15588 9.23333 12.2225V18.667H4.44444C1.98889 18.667 0 20.6559 0 23.1114V36.7003C0 39.1559 1.98889 41.1448 4.44444 41.1448H9.23333V69.0448C9.23333 72.1114 11.7222 74.6003 14.7889 74.6003H65.6C68.6667 74.6003 71.1556 72.1114 71.1556 69.0448V41.1448H76.1556C78.6111 41.1448 80.6 39.1559 80.6 36.7003Z"
//           fill="currentColor"
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_2905_13200">
//           <rect width="80" height="80" fill="currentColor" />
//         </clipPath>
//       </defs>
//     </svg>
//   ),
//   5: () => (
//     <svg
//       width="80"
//       height="80"
//       viewBox="0 0 80 80"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g>
//         <path
//           d="M39.9405 74.4448C39.9405 74.4448 8.55356 43.8737 7.79051 43.0215C0.109109 34.4681 0.41433 21.0444 8.462 13.0896C12.6537 8.94993 18.2494 6.66699 24.2012 6.66699C30.153 6.66699 35.7386 8.93978 39.9303 13.0795C43.9287 9.163 49.1989 6.9308 54.9065 6.75831C61.0313 6.57567 66.9831 8.88905 71.2867 13.0998C75.4682 17.1888 77.7777 22.6475 77.7777 28.4614C77.7777 34.2854 75.4784 39.7442 71.2867 43.8535C70.8289 44.31 70.3507 44.726 69.8114 45.1826L39.9405 74.4448Z"
//           fill="currentColor"
//         />
//       </g>
//     </svg>
//   ),
// };

export const icons_dict = {
  1: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13548)">
        <path
          d="M9.07532 6.88313C9.60968 7.44688 10.4139 7.81559 11.2796 7.81559H11.4265C12.1506 7.81559 12.9494 7.48696 13.3502 7.03809C13.4037 6.97931 14.1544 7.83429 15.6854 7.81559H15.8323C16.5724 7.81559 17.195 7.5591 17.5343 7.10756C17.8736 6.65602 17.9057 5.92128 17.6037 5.46707L16.03 2.60021C16.0194 2.57884 16.006 2.56281 15.9926 2.54678C15.9018 2.39715 15.6907 2.28494 15.5171 2.29563H9.14746M13.3475 7.03542L12.4124 2.38112"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M9.45742 2.29294H2.79392C2.62292 2.28225 2.40918 2.39447 2.31834 2.54409C2.30498 2.56279 2.29162 2.57882 2.28093 2.59753L0.707235 5.46438C0.40532 5.91859 0.437382 6.65334 0.776702 7.10487C1.11602 7.55641 1.73588 7.8129 2.47865 7.8129H2.6256C4.15654 7.83161 4.90732 6.97663 4.96076 7.03541C5.35886 7.48427 6.15773 7.8129 6.88447 7.8129H7.03141C7.89708 7.8129 8.69863 7.44687 9.23566 6.88044M5.89322 2.38111L4.95809 7.03541M9.15016 2.0498V7.14228"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.02979 7.83203V16.7746C2.02979 17.4078 2.5027 17.9261 3.08248 17.9261H15.2018C15.7816 17.9261 16.2545 17.4078 16.2545 16.7746V7.83203"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path d="M16.4308 14.3105H1.6958" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2905_13548">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  2: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13566)">
        <path
          d="M17.4825 16.9179C17.4825 14.5704 16.175 12.5204 14.24 11.4354C13.31 10.9129 12.24 10.6104 11.095 10.6104H6.885C5.7425 10.6104 4.6675 10.9129 3.74 11.4354C1.8075 12.5204 0.5 14.5679 0.5 16.9179H17.4825Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.8 1.25C11.3075 1.25 13.35 3.29 13.35 5.8C13.35 8.31 11.31 10.35 8.8 10.35C6.29 10.35 4.25 8.31 4.25 5.8C4.25 3.29 6.29 1.25 8.8 1.25Z"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13566">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  3: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.05248 17.3044V11.8169C7.05248 11.5269 7.28748 11.2894 7.57498 11.2894H10.2975C10.585 11.2894 10.82 11.5269 10.82 11.8169V17.3044M16.725 7.14187L9.62998 1.90438C9.20748 1.59437 8.66498 1.59437 8.24498 1.90438L1.14748 7.14187C0.864982 7.35187 0.752482 7.70187 0.859982 8.03687C0.969982 8.37437 1.26498 8.59187 1.61748 8.59187H2.28248V16.2894C2.28248 16.8344 2.72498 17.2819 3.26748 17.2819H14.6075C15.15 17.2819 15.5925 16.8369 15.5925 16.2894V8.59187H16.2575C16.6075 8.59187 16.905 8.37437 17.015 8.03687C17.1225 7.70187 17.0125 7.34937 16.73 7.14187H16.725Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path d="M15.7875 8.5918H1.78748" stroke="currentColor" />
    </svg>
  ),
  4: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13555)">
        <path
          d="M2.40491 9.06543V15.5579C2.40491 16.1504 2.84741 16.6354 3.38991 16.6354H14.7299C15.2724 16.6354 15.7149 16.1504 15.7149 15.5579V9.19043"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M15.9249 9.1073H17.1224C17.5124 9.1073 17.8374 8.8048 17.8374 8.4348V5.3498C17.8374 4.9798 17.5124 4.6748 17.1224 4.6748H15.9249"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.24246 9.1073H1.04496C0.654956 9.1073 0.329956 8.8048 0.329956 8.4348V5.3498C0.329956 4.9798 0.654956 4.6748 1.04496 4.6748H2.24246"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.41492 9.19004V3.14254C2.41492 2.50004 2.85742 1.97754 3.39992 1.97754H9.08242"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.28491 9.11215C4.31991 10.1696 6.63241 10.7671 9.08241 10.7671C11.5324 10.7671 13.8949 10.1571 15.9449 9.07715"
          stroke="currentColor"
        />
        <path
          d="M15.7499 9.19004V3.14254C15.7499 2.50004 15.3074 1.97754 14.7649 1.97754H9.0824"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.09753 12.4404H4.59253L5.21753 14.4404H2.09253"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          d="M16.02 12.4404H13.525L12.9 14.4404H16.025"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13555">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.400391)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  5: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.9502V5.2002M5.5 8.5752H12.5"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M16.0793 9.81275C15.9727 9.91622 15.8661 10.0126 15.7453 10.1114L8.98932 16.7002L2.19547 10.0785C2.0486 9.95619 1.89226 9.82451 1.72407 9.63639C0.0516649 7.78344 0.0871975 4.85351 1.8662 3.10402C2.79005 2.19635 4.01711 1.7002 5.32235 1.7002H5.32472C6.73181 1.7002 8.04652 2.28101 8.98459 3.318C10.856 1.25577 14.1108 1.18522 16.0769 3.10402C17.9744 4.95227 17.9744 7.9598 16.0769 9.8104L16.0793 9.81275Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  ),
};

export const small_icons_dict = {
  1: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13548)">
        <path
          d="M9.07532 6.88313C9.60968 7.44688 10.4139 7.81559 11.2796 7.81559H11.4265C12.1506 7.81559 12.9494 7.48696 13.3502 7.03809C13.4037 6.97931 14.1544 7.83429 15.6854 7.81559H15.8323C16.5724 7.81559 17.195 7.5591 17.5343 7.10756C17.8736 6.65602 17.9057 5.92128 17.6037 5.46707L16.03 2.60021C16.0194 2.57884 16.006 2.56281 15.9926 2.54678C15.9018 2.39715 15.6907 2.28494 15.5171 2.29563H9.14746M13.3475 7.03542L12.4124 2.38112"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M9.45742 2.29294H2.79392C2.62292 2.28225 2.40918 2.39447 2.31834 2.54409C2.30498 2.56279 2.29162 2.57882 2.28093 2.59753L0.707235 5.46438C0.40532 5.91859 0.437382 6.65334 0.776702 7.10487C1.11602 7.55641 1.73588 7.8129 2.47865 7.8129H2.6256C4.15654 7.83161 4.90732 6.97663 4.96076 7.03541C5.35886 7.48427 6.15773 7.8129 6.88447 7.8129H7.03141C7.89708 7.8129 8.69863 7.44687 9.23566 6.88044M5.89322 2.38111L4.95809 7.03541M9.15016 2.0498V7.14228"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.02979 7.83203V16.7746C2.02979 17.4078 2.5027 17.9261 3.08248 17.9261H15.2018C15.7816 17.9261 16.2545 17.4078 16.2545 16.7746V7.83203"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path d="M16.4308 14.3105H1.6958" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2905_13548">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  2: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13566)">
        <path
          d="M17.4825 16.9179C17.4825 14.5704 16.175 12.5204 14.24 11.4354C13.31 10.9129 12.24 10.6104 11.095 10.6104H6.885C5.7425 10.6104 4.6675 10.9129 3.74 11.4354C1.8075 12.5204 0.5 14.5679 0.5 16.9179H17.4825Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.8 1.25C11.3075 1.25 13.35 3.29 13.35 5.8C13.35 8.31 11.31 10.35 8.8 10.35C6.29 10.35 4.25 8.31 4.25 5.8C4.25 3.29 6.29 1.25 8.8 1.25Z"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13566">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  3: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.05248 17.3044V11.8169C7.05248 11.5269 7.28748 11.2894 7.57498 11.2894H10.2975C10.585 11.2894 10.82 11.5269 10.82 11.8169V17.3044M16.725 7.14187L9.62998 1.90438C9.20748 1.59437 8.66498 1.59437 8.24498 1.90438L1.14748 7.14187C0.864982 7.35187 0.752482 7.70187 0.859982 8.03687C0.969982 8.37437 1.26498 8.59187 1.61748 8.59187H2.28248V16.2894C2.28248 16.8344 2.72498 17.2819 3.26748 17.2819H14.6075C15.15 17.2819 15.5925 16.8369 15.5925 16.2894V8.59187H16.2575C16.6075 8.59187 16.905 8.37437 17.015 8.03687C17.1225 7.70187 17.0125 7.34937 16.73 7.14187H16.725Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path d="M15.7875 8.5918H1.78748" stroke="currentColor" />
    </svg>
  ),
  4: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13555)">
        <path
          d="M2.40491 9.06543V15.5579C2.40491 16.1504 2.84741 16.6354 3.38991 16.6354H14.7299C15.2724 16.6354 15.7149 16.1504 15.7149 15.5579V9.19043"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M15.9249 9.1073H17.1224C17.5124 9.1073 17.8374 8.8048 17.8374 8.4348V5.3498C17.8374 4.9798 17.5124 4.6748 17.1224 4.6748H15.9249"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.24246 9.1073H1.04496C0.654956 9.1073 0.329956 8.8048 0.329956 8.4348V5.3498C0.329956 4.9798 0.654956 4.6748 1.04496 4.6748H2.24246"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.41492 9.19004V3.14254C2.41492 2.50004 2.85742 1.97754 3.39992 1.97754H9.08242"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.28491 9.11215C4.31991 10.1696 6.63241 10.7671 9.08241 10.7671C11.5324 10.7671 13.8949 10.1571 15.9449 9.07715"
          stroke="currentColor"
        />
        <path
          d="M15.7499 9.19004V3.14254C15.7499 2.50004 15.3074 1.97754 14.7649 1.97754H9.0824"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.09753 12.4404H4.59253L5.21753 14.4404H2.09253"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          d="M16.02 12.4404H13.525L12.9 14.4404H16.025"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13555">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.400391)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  5: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.9502V5.2002M5.5 8.5752H12.5"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M16.0793 9.81275C15.9727 9.91622 15.8661 10.0126 15.7453 10.1114L8.98932 16.7002L2.19547 10.0785C2.0486 9.95619 1.89226 9.82451 1.72407 9.63639C0.0516649 7.78344 0.0871975 4.85351 1.8662 3.10402C2.79005 2.19635 4.01711 1.7002 5.32235 1.7002H5.32472C6.73181 1.7002 8.04652 2.28101 8.98459 3.318C10.856 1.25577 14.1108 1.18522 16.0769 3.10402C17.9744 4.95227 17.9744 7.9598 16.0769 9.8104L16.0793 9.81275Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  ),
};

export const tablet_tab_icons_dict = {
  1: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13548)">
        <path
          d="M9.07532 6.88313C9.60968 7.44688 10.4139 7.81559 11.2796 7.81559H11.4265C12.1506 7.81559 12.9494 7.48696 13.3502 7.03809C13.4037 6.97931 14.1544 7.83429 15.6854 7.81559H15.8323C16.5724 7.81559 17.195 7.5591 17.5343 7.10756C17.8736 6.65602 17.9057 5.92128 17.6037 5.46707L16.03 2.60021C16.0194 2.57884 16.006 2.56281 15.9926 2.54678C15.9018 2.39715 15.6907 2.28494 15.5171 2.29563H9.14746M13.3475 7.03542L12.4124 2.38112"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M9.45742 2.29294H2.79392C2.62292 2.28225 2.40918 2.39447 2.31834 2.54409C2.30498 2.56279 2.29162 2.57882 2.28093 2.59753L0.707235 5.46438C0.40532 5.91859 0.437382 6.65334 0.776702 7.10487C1.11602 7.55641 1.73588 7.8129 2.47865 7.8129H2.6256C4.15654 7.83161 4.90732 6.97663 4.96076 7.03541C5.35886 7.48427 6.15773 7.8129 6.88447 7.8129H7.03141C7.89708 7.8129 8.69863 7.44687 9.23566 6.88044M5.89322 2.38111L4.95809 7.03541M9.15016 2.0498V7.14228"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.02979 7.83203V16.7746C2.02979 17.4078 2.5027 17.9261 3.08248 17.9261H15.2018C15.7816 17.9261 16.2545 17.4078 16.2545 16.7746V7.83203"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path d="M16.4308 14.3105H1.6958" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2905_13548">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  2: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13566)">
        <path
          d="M17.4825 16.9179C17.4825 14.5704 16.175 12.5204 14.24 11.4354C13.31 10.9129 12.24 10.6104 11.095 10.6104H6.885C5.7425 10.6104 4.6675 10.9129 3.74 11.4354C1.8075 12.5204 0.5 14.5679 0.5 16.9179H17.4825Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.8 1.25C11.3075 1.25 13.35 3.29 13.35 5.8C13.35 8.31 11.31 10.35 8.8 10.35C6.29 10.35 4.25 8.31 4.25 5.8C4.25 3.29 6.29 1.25 8.8 1.25Z"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13566">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  3: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.05248 17.3044V11.8169C7.05248 11.5269 7.28748 11.2894 7.57498 11.2894H10.2975C10.585 11.2894 10.82 11.5269 10.82 11.8169V17.3044M16.725 7.14187L9.62998 1.90438C9.20748 1.59437 8.66498 1.59437 8.24498 1.90438L1.14748 7.14187C0.864982 7.35187 0.752482 7.70187 0.859982 8.03687C0.969982 8.37437 1.26498 8.59187 1.61748 8.59187H2.28248V16.2894C2.28248 16.8344 2.72498 17.2819 3.26748 17.2819H14.6075C15.15 17.2819 15.5925 16.8369 15.5925 16.2894V8.59187H16.2575C16.6075 8.59187 16.905 8.37437 17.015 8.03687C17.1225 7.70187 17.0125 7.34937 16.73 7.14187H16.725Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path d="M15.7875 8.5918H1.78748" stroke="currentColor" />
    </svg>
  ),
  4: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13555)">
        <path
          d="M2.40491 9.06543V15.5579C2.40491 16.1504 2.84741 16.6354 3.38991 16.6354H14.7299C15.2724 16.6354 15.7149 16.1504 15.7149 15.5579V9.19043"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M15.9249 9.1073H17.1224C17.5124 9.1073 17.8374 8.8048 17.8374 8.4348V5.3498C17.8374 4.9798 17.5124 4.6748 17.1224 4.6748H15.9249"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.24246 9.1073H1.04496C0.654956 9.1073 0.329956 8.8048 0.329956 8.4348V5.3498C0.329956 4.9798 0.654956 4.6748 1.04496 4.6748H2.24246"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.41492 9.19004V3.14254C2.41492 2.50004 2.85742 1.97754 3.39992 1.97754H9.08242"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.28491 9.11215C4.31991 10.1696 6.63241 10.7671 9.08241 10.7671C11.5324 10.7671 13.8949 10.1571 15.9449 9.07715"
          stroke="currentColor"
        />
        <path
          d="M15.7499 9.19004V3.14254C15.7499 2.50004 15.3074 1.97754 14.7649 1.97754H9.0824"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M2.09753 12.4404H4.59253L5.21753 14.4404H2.09253"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          d="M16.02 12.4404H13.525L12.9 14.4404H16.025"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13555">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.400391)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  5: () => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.9502V5.2002M5.5 8.5752H12.5"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M16.0793 9.81275C15.9727 9.91622 15.8661 10.0126 15.7453 10.1114L8.98932 16.7002L2.19547 10.0785C2.0486 9.95619 1.89226 9.82451 1.72407 9.63639C0.0516649 7.78344 0.0871975 4.85351 1.8662 3.10402C2.79005 2.19635 4.01711 1.7002 5.32235 1.7002H5.32472C6.73181 1.7002 8.04652 2.28101 8.98459 3.318C10.856 1.25577 14.1108 1.18522 16.0769 3.10402C17.9744 4.95227 17.9744 7.9598 16.0769 9.8104L16.0793 9.81275Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  ),
};

export const tablet_icons = {
  filters_icon: () => (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.75H17.75M8 2.75C8 3.14782 7.84196 3.52936 7.56066 3.81066C7.27936 4.09196 6.89782 4.25 6.5 4.25C6.10218 4.25 5.72064 4.09196 5.43934 3.81066C5.15804 3.52936 5 3.14782 5 2.75M8 2.75C8 2.35218 7.84196 1.97064 7.56066 1.68934C7.27936 1.40804 6.89782 1.25 6.5 1.25C6.10218 1.25 5.72064 1.40804 5.43934 1.68934C5.15804 1.97064 5 2.35218 5 2.75M5 2.75H1.25M8 14.75H17.75M8 14.75C8 15.1478 7.84196 15.5294 7.56066 15.8107C7.27936 16.092 6.89782 16.25 6.5 16.25C6.10218 16.25 5.72064 16.092 5.43934 15.8107C5.15804 15.5294 5 15.1478 5 14.75M8 14.75C8 14.3522 7.84196 13.9706 7.56066 13.6893C7.27936 13.408 6.89782 13.25 6.5 13.25C6.10218 13.25 5.72064 13.408 5.43934 13.6893C5.15804 13.9706 5 14.3522 5 14.75M5 14.75H1.25M14 8.75H17.75M14 8.75C14 9.14782 13.842 9.52936 13.5607 9.81066C13.2794 10.092 12.8978 10.25 12.5 10.25C12.1022 10.25 11.7206 10.092 11.4393 9.81066C11.158 9.52936 11 9.14782 11 8.75M14 8.75C14 8.35218 13.842 7.97064 13.5607 7.68934C13.2794 7.40804 12.8978 7.25 12.5 7.25C12.1022 7.25 11.7206 7.40804 11.4393 7.68934C11.158 7.97064 11 8.35218 11 8.75M11 8.75H1.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  res_index_icon: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.4999L9.75 13.7499L13.5 8.49987M10.5 1.46387C8.23574 3.6141 5.22026 4.79344 2.098 4.74987C1.70084 5.95985 1.49898 7.22537 1.5 8.49887C1.5 14.0909 5.324 18.7889 10.5 20.1219C15.676 18.7899 19.5 14.0919 19.5 8.49987C19.5 7.18987 19.29 5.92887 18.902 4.74887H18.75C15.554 4.74887 12.65 3.50087 10.5 1.46387Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reports_icon: () => (
    <svg
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 13V10.375C16 9.47989 15.6444 8.62145 15.0115 7.98851C14.3786 7.35558 13.5201 7 12.625 7H11.125C10.8266 7 10.5405 6.88147 10.3295 6.6705C10.1185 6.45952 10 6.17337 10 5.875V4.375C10 3.47989 9.64442 2.62145 9.01149 1.98851C8.37855 1.35558 7.52011 1 6.625 1H4.75M5.5 15.25V16M8.5 13V16M11.5 10.75V16M7 1H2.125C1.504 1 1 1.504 1 2.125V19.375C1 19.996 1.504 20.5 2.125 20.5H14.875C15.496 20.5 16 19.996 16 19.375V10C16 7.61305 15.0518 5.32387 13.364 3.63604C11.6761 1.94821 9.38695 1 7 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sun_icon: () => (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 3.75V1.5C10.75 1.30109 10.829 1.11032 10.9697 0.96967C11.1103 0.829018 11.3011 0.75 11.5 0.75C11.6989 0.75 11.8897 0.829018 12.0303 0.96967C12.171 1.11032 12.25 1.30109 12.25 1.5V3.75C12.25 3.94891 12.171 4.13968 12.0303 4.28033C11.8897 4.42098 11.6989 4.5 11.5 4.5C11.3011 4.5 11.1103 4.42098 10.9697 4.28033C10.829 4.13968 10.75 3.94891 10.75 3.75ZM17.5 12C17.5 13.1867 17.1481 14.3467 16.4888 15.3334C15.8295 16.3201 14.8925 17.0892 13.7961 17.5433C12.6997 17.9974 11.4933 18.1162 10.3295 17.8847C9.16557 17.6532 8.09647 17.0818 7.25736 16.2426C6.41824 15.4035 5.8468 14.3344 5.61529 13.1705C5.38378 12.0067 5.5026 10.8003 5.95672 9.7039C6.41085 8.60754 7.17988 7.67047 8.16658 7.01118C9.15327 6.35189 10.3133 6 11.5 6C13.0908 6.00174 14.6159 6.63444 15.7407 7.75928C16.8656 8.88412 17.4983 10.4092 17.5 12ZM16 12C16 11.11 15.7361 10.24 15.2416 9.49993C14.7471 8.75991 14.0443 8.18314 13.2221 7.84254C12.3998 7.50195 11.495 7.41283 10.6221 7.58647C9.74918 7.7601 8.94736 8.18868 8.31802 8.81802C7.68868 9.44736 7.2601 10.2492 7.08647 11.1221C6.91283 11.995 7.00195 12.8998 7.34254 13.7221C7.68314 14.5443 8.25991 15.2471 8.99993 15.7416C9.73995 16.2361 10.61 16.5 11.5 16.5C12.6931 16.4988 13.837 16.0243 14.6806 15.1806C15.5243 14.337 15.9988 13.1931 16 12ZM4.96938 6.53063C5.11011 6.67136 5.30098 6.75042 5.5 6.75042C5.69902 6.75042 5.88989 6.67136 6.03063 6.53063C6.17136 6.38989 6.25042 6.19902 6.25042 6C6.25042 5.80098 6.17136 5.61011 6.03063 5.46938L4.53062 3.96938C4.38989 3.82864 4.19902 3.74958 4 3.74958C3.80098 3.74958 3.61011 3.82864 3.46938 3.96938C3.32864 4.11011 3.24958 4.30098 3.24958 4.5C3.24958 4.69902 3.32864 4.88989 3.46938 5.03062L4.96938 6.53063ZM4.96938 17.4694L3.46938 18.9694C3.32864 19.1101 3.24958 19.301 3.24958 19.5C3.24958 19.699 3.32864 19.8899 3.46938 20.0306C3.61011 20.1714 3.80098 20.2504 4 20.2504C4.19902 20.2504 4.38989 20.1714 4.53062 20.0306L6.03063 18.5306C6.10031 18.4609 6.15558 18.3782 6.1933 18.2872C6.23101 18.1961 6.25042 18.0985 6.25042 18C6.25042 17.9015 6.23101 17.8039 6.1933 17.7128C6.15558 17.6218 6.10031 17.5391 6.03063 17.4694C5.96094 17.3997 5.87822 17.3444 5.78717 17.3067C5.69613 17.269 5.59855 17.2496 5.5 17.2496C5.40145 17.2496 5.30387 17.269 5.21283 17.3067C5.12178 17.3444 5.03906 17.3997 4.96938 17.4694ZM17.5 6.75C17.5985 6.75008 17.6961 6.73074 17.7871 6.6931C17.8782 6.65546 17.9609 6.60025 18.0306 6.53063L19.5306 5.03062C19.6714 4.88989 19.7504 4.69902 19.7504 4.5C19.7504 4.30098 19.6714 4.11011 19.5306 3.96938C19.3899 3.82864 19.199 3.74958 19 3.74958C18.801 3.74958 18.6101 3.82864 18.4694 3.96938L16.9694 5.46938C16.8644 5.57427 16.7928 5.70796 16.7639 5.85352C16.7349 5.99908 16.7497 6.14998 16.8065 6.28709C16.8633 6.42421 16.9596 6.54139 17.083 6.62379C17.2065 6.70619 17.3516 6.75012 17.5 6.75ZM18.0306 17.4694C17.8899 17.3286 17.699 17.2496 17.5 17.2496C17.301 17.2496 17.1101 17.3286 16.9694 17.4694C16.8286 17.6101 16.7496 17.801 16.7496 18C16.7496 18.199 16.8286 18.3899 16.9694 18.5306L18.4694 20.0306C18.5391 20.1003 18.6218 20.1556 18.7128 20.1933C18.8039 20.231 18.9015 20.2504 19 20.2504C19.0985 20.2504 19.1961 20.231 19.2872 20.1933C19.3782 20.1556 19.4609 20.1003 19.5306 20.0306C19.6003 19.9609 19.6556 19.8782 19.6933 19.7872C19.731 19.6961 19.7504 19.5985 19.7504 19.5C19.7504 19.4015 19.731 19.3039 19.6933 19.2128C19.6556 19.1218 19.6003 19.0391 19.5306 18.9694L18.0306 17.4694ZM4 12C4 11.8011 3.92098 11.6103 3.78033 11.4697C3.63968 11.329 3.44891 11.25 3.25 11.25H1C0.801088 11.25 0.610322 11.329 0.46967 11.4697C0.329018 11.6103 0.25 11.8011 0.25 12C0.25 12.1989 0.329018 12.3897 0.46967 12.5303C0.610322 12.671 0.801088 12.75 1 12.75H3.25C3.44891 12.75 3.63968 12.671 3.78033 12.5303C3.92098 12.3897 4 12.1989 4 12ZM11.5 19.5C11.3011 19.5 11.1103 19.579 10.9697 19.7197C10.829 19.8603 10.75 20.0511 10.75 20.25V22.5C10.75 22.6989 10.829 22.8897 10.9697 23.0303C11.1103 23.171 11.3011 23.25 11.5 23.25C11.6989 23.25 11.8897 23.171 12.0303 23.0303C12.171 22.8897 12.25 22.6989 12.25 22.5V20.25C12.25 20.0511 12.171 19.8603 12.0303 19.7197C11.8897 19.579 11.6989 19.5 11.5 19.5ZM22 11.25H19.75C19.5511 11.25 19.3603 11.329 19.2197 11.4697C19.079 11.6103 19 11.8011 19 12C19 12.1989 19.079 12.3897 19.2197 12.5303C19.3603 12.671 19.5511 12.75 19.75 12.75H22C22.1989 12.75 22.3897 12.671 22.5303 12.5303C22.671 12.3897 22.75 12.1989 22.75 12C22.75 11.8011 22.671 11.6103 22.5303 11.4697C22.3897 11.329 22.1989 11.25 22 11.25Z"
        fill="currentColor"
      />
    </svg>
  ),
  exit_icon: () => (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 7V3.25C11.25 2.65326 11.0129 2.08097 10.591 1.65901C10.169 1.23705 9.59674 1 9 1H3C2.40326 1 1.83097 1.23705 1.40901 1.65901C0.987053 2.08097 0.75 2.65326 0.75 3.25V16.75C0.75 17.3467 0.987053 17.919 1.40901 18.341C1.83097 18.7629 2.40326 19 3 19H9C9.59674 19 10.169 18.7629 10.591 18.341C11.0129 17.919 11.25 17.3467 11.25 16.75V13M7.5 7L4.5 10M4.5 10L7.5 13M4.5 10H17.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  presets_icon: () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 7.5V6.108C8.75 4.973 9.595 4.01 10.726 3.916C11.099 3.886 11.474 3.859 11.849 3.836M16.25 18H18.5C19.0967 18 19.669 17.7629 20.091 17.341C20.5129 16.919 20.75 16.3467 20.75 15.75V6.108C20.75 4.973 19.905 4.01 18.774 3.916C18.4 3.88498 18.0256 3.85831 17.651 3.836M17.651 3.836C17.509 3.3767 17.2226 2.97493 16.8357 2.68954C16.4489 2.40414 15.9808 2.25011 15.5 2.25H14C13.5192 2.25011 13.0511 2.40414 12.6643 2.68954C12.2774 2.97493 11.992 3.3767 11.85 3.836C11.785 4.046 11.75 4.269 11.75 4.5V5.25H17.75V4.5C17.75 4.269 17.716 4.046 17.651 3.836ZM16.25 18.75V16.875C16.25 15.9799 15.8944 15.1215 15.2615 14.4885C14.6285 13.8556 13.7701 13.5 12.875 13.5H11.375C11.0766 13.5 10.7905 13.3815 10.5795 13.1705C10.3685 12.9595 10.25 12.6734 10.25 12.375V10.875C10.25 9.97989 9.89442 9.12145 9.26149 8.48851C8.62855 7.85558 7.77011 7.5 6.875 7.5H5.75M7.25 7.5H5.375C4.754 7.5 4.25 8.004 4.25 8.625V20.625C4.25 21.246 4.754 21.75 5.375 21.75H15.125C15.746 21.75 16.25 21.246 16.25 20.625V16.5C16.25 14.1131 15.3018 11.8239 13.614 10.136C11.9261 8.44821 9.63695 7.5 7.25 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  compare_icon: () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 21L3.5 16.5M3.5 16.5L8 12M3.5 16.5H17M17 3L21.5 7.5M21.5 7.5L17 12M21.5 7.5H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  hide_icon: () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 19.5L11.75 12L19.25 4.5M13.25 19.5L5.75 12L13.25 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export const tablet_cards_icons_dict = {
  1: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M75.9174 19.4283L69.4063 7.55053C69.3396 7.42831 69.273 7.32831 69.173 7.20608C68.5063 6.18386 67.173 5.49497 66.0507 5.56164H13.2396C12.0285 5.48386 10.7063 6.17275 10.0396 7.19497C9.95074 7.30608 9.88408 7.4172 9.8063 7.55053L3.28408 19.4283C1.73963 21.8061 1.89519 25.4728 3.65074 27.8061C4.76185 29.295 6.47296 30.3394 8.52852 30.8839V68.2839C8.52852 71.0839 11.0174 73.3616 14.0841 73.3616H64.8952C67.9619 73.3616 70.4507 71.0839 70.4507 68.2839V30.9394C72.6063 30.4172 74.3952 29.3505 75.5507 27.8061C77.2952 25.4728 77.4507 21.8061 75.9174 19.4283Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  3: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M65.995 76.5971H15.595C12.4173 76.5971 9.82837 73.9971 9.82837 70.7971V37.9749H8.26171C6.09504 37.9749 4.2506 36.6304 3.58393 34.5527C2.91726 32.4749 3.60615 30.3082 5.3506 29.0193L36.895 5.75267C39.2617 4.00822 42.3284 4.00822 44.695 5.75267L76.2395 29.0304C77.9728 30.3193 78.6728 32.486 77.995 34.5527C77.3284 36.6304 75.4839 37.9749 73.3173 37.9749H71.7506V70.7971C71.7506 73.9971 69.1617 76.5971 65.9839 76.5971H65.995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  2: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M64.2555 48.7886C59.7889 46.2775 54.7111 44.9441 49.5889 44.9441H48.3778C56.2666 41.7219 61.8333 33.9775 61.8333 24.9441C61.8444 13.0219 52.1444 3.33301 40.2333 3.33301C28.3222 3.33301 18.6333 13.0219 18.6333 24.9441C18.6333 33.9775 24.2111 41.7219 32.0889 44.9441H30.8778C25.7555 44.9441 20.6889 46.2775 16.2111 48.7886C6.89997 54.0108 1.11108 63.8108 1.11108 74.3552C1.11108 75.1219 1.73331 75.7441 2.49997 75.7441H77.9777C78.7444 75.7441 79.3666 75.1219 79.3666 74.3552C79.3666 63.8108 73.5778 54.0108 64.2555 48.7775V48.7886Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  4: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2905_13200)">
        <path
          d="M80.6 36.7003V23.1114C80.6 20.6559 78.6111 18.667 76.1556 18.667H71.1556V12.2225C71.1556 9.15588 68.6667 6.66699 65.6 6.66699H14.7889C11.7222 6.66699 9.23333 9.15588 9.23333 12.2225V18.667H4.44444C1.98889 18.667 0 20.6559 0 23.1114V36.7003C0 39.1559 1.98889 41.1448 4.44444 41.1448H9.23333V69.0448C9.23333 72.1114 11.7222 74.6003 14.7889 74.6003H65.6C68.6667 74.6003 71.1556 72.1114 71.1556 69.0448V41.1448H76.1556C78.6111 41.1448 80.6 39.1559 80.6 36.7003Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2905_13200">
          <rect width="80" height="80" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  5: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M39.9405 74.4448C39.9405 74.4448 8.55356 43.8737 7.79051 43.0215C0.109109 34.4681 0.41433 21.0444 8.462 13.0896C12.6537 8.94993 18.2494 6.66699 24.2012 6.66699C30.153 6.66699 35.7386 8.93978 39.9303 13.0795C43.9287 9.163 49.1989 6.9308 54.9065 6.75831C61.0313 6.57567 66.9831 8.88905 71.2867 13.0998C75.4682 17.1888 77.7777 22.6475 77.7777 28.4614C77.7777 34.2854 75.4784 39.7442 71.2867 43.8535C70.8289 44.31 70.3507 44.726 69.8114 45.1826L39.9405 74.4448Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
};
